import React from "react";
import { Box, Typography } from "@mui/material";
import GradeSlider from "./GradeSlider";

export default function SkillRow({
  displayName,
  experienceLabel,
  levelValue,
  onChangeLevel,
  isChild = false,
  isDesktop,
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: isDesktop
          ? "minmax(140px, 0.28fr) minmax(240px, 0.72fr)"
          : "1fr",
        alignItems: "center",
        columnGap: isDesktop ? 6 : 0,
        rowGap: 1,
        p: isDesktop ? 2 : 0,
        ml: 0,
      }}
    >
      {/* 左側（スキル名＋年数） */}
      <Box
        sx={{
          textAlign: "left",
          pl: isDesktop ? (isChild ? 5 : 0) : 0,
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {displayName}
        </Typography>

        <Typography sx={{ color: "#4B5563" }}>{experienceLabel}</Typography>
      </Box>

      {/* 右側（スライダー） */}
      <GradeSlider levelValue={levelValue} onChangeLevel={onChangeLevel} />
    </Box>
  );
}
